
import Icon from '@ant-design/icons';
import * as React from 'react';

const ErrorIconSvg = (props) => {
    return (
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 36C0 16.1156 16.1156 0 36 0C55.8844 0 72 16.1156 72 36C72 55.8844 55.8844 72 36 72C16.1156 72 0 55.8844 0 36ZM50.4278 50.4712C51.4192 49.4868 51.4192 47.8837 50.4349 46.8923L39.5716 36.0009L50.4349 25.1024C51.4192 24.111 51.4192 22.5079 50.4278 21.5235C49.4364 20.5392 47.8333 20.5392 46.8489 21.5306L35.9997 32.4149L25.1505 21.5376C24.1661 20.5462 22.563 20.5462 21.5716 21.5306C20.5802 22.5149 20.5802 24.1181 21.5646 25.1095L32.4278 36.0009L21.5646 46.8923C20.5802 47.8837 20.5802 49.4868 21.5716 50.4712C22.0638 50.9634 22.7106 51.2095 23.3575 51.2095C24.0044 51.2095 24.6583 50.9634 25.1505 50.4642L35.9997 39.5868L46.8489 50.4642C47.3411 50.9634 47.995 51.2095 48.6419 51.2095C49.2888 51.2095 49.9356 50.9634 50.4278 50.4712Z" fill="#D61F1F" />
        </svg>
    );
};

export const ErrorIcon = props => (
    <Icon component={ErrorIconSvg} {...props} />
);
